export const housekeepingDrawer = {
  close: "Chiudi",
  guest: "Ospite",

  cleaning: {
    title: "Stato della pulizia",
    lastCleaned: "Pulita {date}",
    evidenceAlt: "prova",
  },

  status: {
    dirty: "Da pulire",
    in_progress: "In corso",
    clean: "Pulita",
    inspected: "Ispezionata",
    out_of_service: "Fuori servizio",
  },

  occupancy: {
    title: "Occupazione",
    aboutToLeave: "In partenza",
    checkIn: "Check-in {date}",
    checkOut: "Check-out {date}",
    checkoutTime: "Check-out {time}",
    booking: "Prenotazione {code}",
    nextArrivalToday: "Prossimo arrivo oggi",
    fromTime: "dalle {time}",
    labels: {
      vacant: "Libera",
      occupied: "Occupata",
      departure_today: "Parte oggi",
      arrival_today: "Arriva oggi",
      turnover: "Partenza e arrivo oggi",
    },
  },

  window: {
    windowLabel: "Finestra",
    standardSchedule: "Orario standard",
    sub: "{label}: check-out {checkout} → check-in {checkin}",
    overdue: "Arrivo in ritardo · dai priorità a questa pulizia",
    untilArrival: "{dur} all'arrivo",
  },

  tasks: {
    title: "Attività di pulizia",
    // Pluralization (vue-i18n v8 pipes) — choiceIndex = number of open tasks
    pendingCount: "{count} in sospeso | {count} in sospeso",
    newPlaceholder: "Aggiungi un'attività (es. Cambiare gli asciugamani)",
    priorityTitle: "Priorità",
    dateTitle: "Data",
    timeTitle: "Ora (facoltativo)",
    assignTitle: "Assegna a",
    assignAllOption: "Tutti (pulizia e manutenzione)",
    byRole: "Per ruolo",
    wholeRoleSuffix: "(intero ruolo)",
    people: "Persone",
    add: "Aggiungi",
    adding: "Aggiunta in corso…",
    loading: "Caricamento attività…",
    empty: "Nessuna attività. Aggiungi la prima qui sopra.",
    markPending: "Segna come in sospeso",
    markDone: "Segna come completata",
    priorityDotTitle: "Priorità {priority}",
    delete: "Elimina",
  },

  enc: {
    late: "Overdue",
    title: "Requests for this room",
    what: "One-off things besides the cleaning: restock something, check a fault, a treat for the guest. Whoever goes to the room will see it and tick it off.",
    protocolNote: "The cleaning steps are in the protocol above. This is only for extras.",
    emptyTitle: "No pending requests",
    emptyExamples: "For example: “Replace the bathroom light bulb” or “Leave a welcome bottle of wine”.",
    newBtn: "New request",
    qWhat: "What needs doing?",
    whatPlaceholder: "Write it in your own words…",
    suggestions: "Restock coffee and sugar | Replace a light bulb | Check the air conditioning | Leave extra towels | Check the wifi | Welcome treat",
    qWhen: "When?",
    today: "Today",
    tomorrow: "Tomorrow",
    otherDay: "Another day",
    anyDay: "No date",
    atTime: "At a specific time",
    qWho: "Who does it?",
    whoever: "Whoever cleans",
    isUrgent: "It's urgent",
    urgentHint: "It will stand out and be flagged first.",
    urgent: "Urgent",
    preview: "“{what}” · {when} · {who}",
    cancel: "Cancel",
    save: "Save request",
    showDone: "Show {count} done | Show {count} done",
    hideDone: "Hide done",
    confirmDelete: "Delete the request “{what}”?",
  },

  priority: {
    low: "Bassa",
    normal: "Normale",
    high: "Alta",
    urgent: "Urgente",
  },

  roles: {
    limpieza: "Pulizia",
    mantenimiento: "Manutenzione",
    propietario: "Proprietario",
  },

  assignee: {
    assigned: "Assegnata",
    all: "Tutti",
  },
};
